<!--区域超速提醒-->

<template>
    <div>
      <limitarearemindset />
    </div>
  </template>
  <script>
  import limitarearemindset from "./components/limitarearemindset";
  export default {
    name:"arealimitremind",
    components: {
        limitarearemindset,
    },
    mounted() {
      this.$store.dispatch("app/closeSideBar");
    },
    destroyed() {
      this.$store.dispatch("app/openSideBar");
    },
  };
  </script>
  